const ls = require('local-storage'); // tslint:disable-line

export default function generateUUID(len: number, radix?: number) {
    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    const uuid: string[] = [];
    radix = radix || chars.length;

    if (len) {
        // Compact form
        for (let i = 0; i < len; i++) {
            uuid[i] = chars[0 | Math.random() * radix]; // tslint:disable-line
        }
    } else {
        let r;

        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';

        for (let i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16; // tslint:disable-line
                uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]; // tslint:disable-line
            }
        }
    }

    return uuid.join('');
}

export function getUUID() {
    let uuid = ls.get('_prajna_uuid');
    if (uuid) {
        return uuid;
    } else {
        uuid = `${Date.now().toString()}${generateUUID(6)}`;
        ls.set('_prajna_uuid', uuid);
        return uuid;
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/util/uuid.ts